import { Spin, SpinProps } from 'antd';

export interface LoadingSpinnerProps {
  size?: SpinProps['size'];
}

/** A centered loading spinner that fills its relatively-positioned parent. */
export function LoadingSpinner({
  size = 'large',
}: Readonly<LoadingSpinnerProps>) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size={size} aria-label="Loading..." />
    </div>
  );
}
